import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import { AdminProtected } from "@/components/Application/AdminProtected";

import PageError from "@/helpers/components/Errors/PageError";

export const CommonRoutes: RouteObject[] = [
	{
		path: "updatedprocedures",
		lazy: async () => {
			const { ShowUpdatedProcedures: ShowUpdatedProcedures } = await import(
				"@/components/Procedures/ShowUpdatedProcedures"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<ShowUpdatedProcedures />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "viewupdatedprocedure/:id/parrent/:groupId",
		children: [
			{
				index: true,
				lazy: async () => {
					const { UpdatedProceduresDetails } = await import(
						"@/components/Procedures/UpdatedProceduresDetails"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<UpdatedProceduresDetails source="updatelist" />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
			{
				path: "schemeId/:schemId/showpage/:checklistId",
				lazy: async () => {
					const { UpdatedProceduresDetails } = await import(
						"@/components/Procedures/UpdatedProceduresDetails"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<UpdatedProceduresDetails source="updatelist" />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
		],
	},
	{
		path: "viewuppdatednode/:id/parrent/:groupId",
		children: [
			{
				index: true,
				lazy: async () => {
					const { UpdatedProceduresDetails } = await import(
						"@/components/Procedures/UpdatedProceduresDetails"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<UpdatedProceduresDetails source="node" />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
			{
				path: "schemeId/:schemeId/showpage/:checklistid",
				lazy: async () => {
					const { UpdatedProceduresDetails } = await import(
						"@/components/Procedures/UpdatedProceduresDetails"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<UpdatedProceduresDetails source="node" />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
		],
	},
	{
		path: "updatenodedocument/:id/*",
		children: [
			{
				path: "checklist/:schemeId/*",
				children: [
					{
						path: "newpage",
						lazy: async () => {
							const { UpdateNodeDocument } = await import(
								"@/components/Procedures/UpdateNodeDocument"
							);
							return {
								Component: () => (
									<Sentry.ErrorBoundary
										fallback={({ error, componentStack, resetError }) => (
											<PageError
												error={error}
												componentStack={componentStack}
												reset={resetError}
											/>
										)}
									>
										<UpdateNodeDocument newpage={true} />
									</Sentry.ErrorBoundary>
								),
							};
						},
					},
					{
						path: "editnode/:redirectto",
						lazy: async () => {
							const { UpdateNodeDocument } = await import(
								"@/components/Procedures/UpdateNodeDocument"
							);
							return {
								Component: () => (
									<Sentry.ErrorBoundary
										fallback={({ error, componentStack, resetError }) => (
											<PageError
												error={error}
												componentStack={componentStack}
												reset={resetError}
											/>
										)}
									>
										<UpdateNodeDocument editnode={true} />
									</Sentry.ErrorBoundary>
								),
							};
						},
					},
				],
			},
			{
				path: "schemeId/:schemeId/",
				lazy: async () => {
					const { UpdateNodeDocument } = await import(
						"@/components/Procedures/UpdateNodeDocument"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<UpdateNodeDocument editnode={false} />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
		],
	},
	{
		path: "/redirectondocumentupdate/:id/schemeId/:schemeId",
		lazy: async () => {
			const { RedirectOnDocumentUpdate } = await import(
				"@/components/Procedures/UpdateNodeDocument"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<RedirectOnDocumentUpdate />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "showdocumentsused/*",
		children: [
			{
				index: true,
				lazy: async () => {
					const { ShowDocumentsUsed } = await import(
						"@/components/Procedures/ShowDocumentsUsed"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<ShowDocumentsUsed />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
			{
				path: ":id",
				lazy: async () => {
					const { ShowDocumentsUsed } = await import(
						"@/components/Procedures/ShowDocumentsUsed"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<ShowDocumentsUsed />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
		],
	},
	{
		path: "updatedprocedures",
		lazy: async () => {
			const { ShowUpdatedProcedures: ShowUpdatedProcedures } = await import(
				"@/components/Procedures/ShowUpdatedProcedures"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<ShowUpdatedProcedures />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "components6040",
		lazy: async () => {
			const { DevelopmentComponent6040 } = await import(
				"@/components/DevelopmentComponents/DevelopmentComponent6040"
			);
			return { Component: DevelopmentComponent6040 };
		},
	},
	{
		path: "components5050",
		lazy: async () => {
			const { DevelopmentComponent5050 } = await import(
				"@/components/DevelopmentComponents/DevelopmentComponent5050"
			);
			return { Component: DevelopmentComponent5050 };
		},
	},
	{
		path: "admin/dashboard",
		lazy: async () => {
			const { AdminDashboard } = await import(
				"@/components/Admin/AdminDashboard/components/AdminDashboard"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<AdminProtected>
							<AdminDashboard />
						</AdminProtected>
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
];
